// Default time of a task without end time
export const LENGTH_TASKS_MINUTES = 30;

export const LAST_HOUR = 23;

export const SHORT_SLOT_LENGTH = 30;
export const MEDIUMT_SLOT_LENGTH = 60;

export const UNASSIGNED_CALENDAR_EVENT = "UNASSIGNED";
export const UNASSIGNED_OPEN_SLOT_CALENDAR_EVENT = "UNASSIGNED_OPEN_SLOT";

export const isUnassignedLane = (emailId: string): boolean =>
  emailId === UNASSIGNED_CALENDAR_EVENT ||
  emailId === UNASSIGNED_OPEN_SLOT_CALENDAR_EVENT;
